"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleAction = void 0;
const execute_logic_1 = __importDefault(require("../utils/execute-logic"));
const resolvers_1 = require("../utils/resolvers");
const update_model_1 = require("../utils/update-model");
const type_conversion_1 = require("../utils/type-conversion");
const constants_1 = require("../constants");
const reporter_1 = __importDefault(require("../reporter"));
const getValue = (node, models, repeatIndex) => typeof node === 'object'
    ? (0, execute_logic_1.default)({ ast: node, data: { models, repeatIndex } })
    : node;
const handleRef = ({ modelRef, actionEntry, models, repeatIndex }) => {
    const { value, if: evalIf } = actionEntry;
    if (evalIf && !(0, execute_logic_1.default)({ ast: evalIf, data: { models, repeatIndex } }))
        return models;
    const { attr } = modelRef;
    return (0, update_model_1.updateModels)({
        models,
        modelRef,
        [attr || constants_1.MODEL_CONTENTS]: (0, type_conversion_1.equivalentString)(getValue(value, models, repeatIndex)),
        repeatIndex,
    });
};
const handleAction = ({ models, actionEntry, binds, repeatIndex }) => {
    const { modelRef, bind, bindIndex } = actionEntry;
    const activeRef = (0, resolvers_1.getActiveRef)({ modelRef, binds, bind, bindIndex });
    if (Array.isArray(activeRef)) {
        activeRef.forEach(refN => {
            (0, exports.handleAction)({
                models,
                actionEntry: {
                    ...actionEntry,
                    modelRef: refN,
                    bind: undefined,
                    bindIndex: undefined,
                },
                binds,
                repeatIndex,
            });
        });
        return models;
    }
    return handleRef({
        modelRef: activeRef,
        actionEntry,
        models,
        binds,
        repeatIndex,
    });
};
exports.handleAction = handleAction;
// Receive the actions array, binds, and initial model,
// returns an updated model with all changes applied
const handleActions = ({ actions, binds, repeatIndex }) => models => {
    reporter_1.default.perf(`Running ${actions.length} actions`);
    actions.forEach(actionEntry => {
        (0, exports.handleAction)({ models, actionEntry, binds, repeatIndex });
    });
    return models;
};
exports.default = handleActions;
//# sourceMappingURL=handle-action.js.map